import { render, staticRenderFns } from "./FormAssetTextEditor.vue?vue&type=template&id=e03ab7a0&scoped=true&lang=pug"
import script from "./FormAssetTextEditor.vue?vue&type=script&lang=js"
export * from "./FormAssetTextEditor.vue?vue&type=script&lang=js"
import style0 from "./FormAssetTextEditor.vue?vue&type=style&index=0&id=e03ab7a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03ab7a0",
  null
  
)

export default component.exports